export default function Eshops() {
  return (
    <>
      <h1 className="page-title">Eshops</h1>
    </>
  );
}
